import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import dayjs from "dayjs";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Controller } from "react-hook-form";

import styles from "../../sourcedocs.module.scss";

const BaseAOOHHeadlinesForm = (props) => {
  const {
    control,
    dataObj,
    formState,
    onTextBlur,
    subheads,
    onAddSubhead,
    onRemoveSubhead,
    onSubheadTextChange,
  } = props;

  return (
    <Box>
      <Grid
        container
        rowSpacing={2}
        columnSpacing={{ sm: 0, md: 12 }}
        direction={{ sm: "column", md: "row" }}
      >
        <Grid item sm={12} md={6}>
          <div>
            <label className={`required font ${styles.labelText}`}>Ref Id</label>
          </div>
          <Controller
            name="refid"
            control={control}
            render={({
              field: { onChange, onBlur, value },
              fieldState: { error },
            }) => (
              <TextField
                margin="dense"
                id="refid"
                fullWidth
                size="small"
                variant="outlined"
                name="refid"
                onBlur={onBlur}
                onChange={onChange}
                error={!!error}
                helperText={error ? error.message : undefined}
                value={value}
              />
            )}
          />
        </Grid>
        {dataObj && (
          <Grid item sm={12} md={6}>
            <div>
              <label className={`font ${styles.labelText}`}>Last Updated By</label>
            </div>
            <Typography variant="subtitle1">{dataObj?.modifyusername}</Typography>
          </Grid>
        )}
        {dataObj && (
          <Grid item sm={12} md={6}>
            <div>
              <label className={`font ${styles.labelText}`}>Last Updated Date</label>
            </div>
            <Typography variant="subtitle1">
              {dayjs(dataObj?.modifydatetime || dataObj?.createdatetime).format(
                "YYYY/MM/DD hh:mm:ss A"
              )}
            </Typography>
          </Grid>
        )}
        <Grid item sm={12}>
          <div>
            <label className={`font ${styles.labelText}`}>Template text</label>
          </div>
          <Controller
            name="template_text"
            control={control}
            render={({ field: { onBlur, onChange, value } }) => (
              <TextField
                id="templateText"
                fullWidth
                size="small"
                variant="outlined"
                name="templateText"
                placeholder="Enter template text"
                multiline
                minRows={3}
                value={value}
                onBlur={(e) => {
                  onBlur(e);
                  onTextBlur(e);
                }}
                onChange={(e) => onChange(e.target.value)}
              />
            )}
          />
        </Grid>
        <Grid item sm={12}>
          <div>
            <label className={`font ${styles.labelText}`}>Disclaimer</label>
          </div>
          <Controller
            name="disclaimer_text"
            control={control}
            render={({ field: { onBlur, onChange, value } }) => (
              <TextField
                id="disclaimerText"
                fullWidth
                size="small"
                variant="outlined"
                name="disclaimerText"
                placeholder="Enter disclaimer text"
                multiline
                minRows={3}
                value={value}
                onBlur={onBlur}
                onChange={(e) => onChange(e.target.value)}
              />
            )}
          />
        </Grid>
        <Grid item sm={12}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
            <label className={`font ${styles.labelText}`}>Subheads</label>
            <Button variant="outlined" size="small" onClick={onAddSubhead}>
              Add subhead
            </Button>
          </Box>
          {subheads?.length === 0 && (
            <Typography variant="body2" color="text.secondary">
              No subheads added.
            </Typography>
          )}
          {subheads?.map((row, index) => (
            <Box key={row.clientId} sx={{ display: "flex", gap: 1, mb: 2, alignItems: "flex-start" }}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label={`Subhead ${index + 1}`}
                multiline
                minRows={2}
                value={row.subhead_text}
                onChange={(e) => onSubheadTextChange(row.clientId, e.target.value)}
              />
              <IconButton
                aria-label="Remove subhead"
                onClick={() => onRemoveSubhead(row.clientId)}
                size="small"
              >
                <DeleteOutlineIcon />
              </IconButton>
            </Box>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};

export default BaseAOOHHeadlinesForm;
